import { render, staticRenderFns } from "./ProjectFrom.vue?vue&type=template&id=049ec7e0&scoped=true&"
import script from "./ProjectFrom.vue?vue&type=script&lang=js&"
export * from "./ProjectFrom.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFrom.vue?vue&type=style&index=0&id=049ec7e0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ec7e0",
  null
  
)

export default component.exports